// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import Constant from "../../utils/constant";
// import { useNavigate } from "react-router-dom";
// import xls from "../../assets/img/xls.png";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// export default function Attendance() {
//   const [attendanceData, setAttendanceData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const [totalItems, setTotalItems] = useState(0);
//   const [selectedMonth, setSelectedMonth] = useState("2025-04");
//   const fileInputRef = useRef(null);
//   // const history = useNavigate();

//   // const fetchAttendanceData = async (page, month) => {
//   //   setLoading(true);
//   //   try {
//   //     const response = await axios.get(
//   //       `http://localhost:1051/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
//   //       // `https://api.policicue.com/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
//   //     );
//   //     const data = response.data.data || [];
//   //     setAttendanceData(data);
//   //     setTotalItems(response.data.total || 0);
//   //   } catch (error) {
//   //     console.error("Error fetching attendance data:", error);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };
//   const fetchAttendanceData = async (page, month) => {
//     setLoading(true);
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
//         `https://api.policicue.com/hrms/attendance-by-month?month=${month}&page=${page}&limit=${itemsPerPage}`
//       );
//       const data = response.data.data || [];
//       // This is the key line:
//       setAttendanceData(data);
//       setTotalItems(response.data.total || 0);
//     } catch (error) {
//       console.error("Error fetching attendance data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     fetchAttendanceData(currentPage, selectedMonth);
//   }, [currentPage, selectedMonth]);

//   const handleNextPage = () => {
//     if (currentPage * itemsPerPage < totalItems) {
//       setCurrentPage((prev) => prev + 1);
//     }
//   };

//   const handlePreviousPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage((prev) => prev - 1);
//     }
//   };

//   const handleMonthChange = (e) => {
//     setSelectedMonth(e.target.value);
//     setCurrentPage(1);
//   };

//   const downloadExcel = async () => {
//     try {
//       const response = await axios.get(
//         // `http://localhost:1051/hrms/attendance/download?month=${selectedMonth}`,
//         `https://api.policicue.com/hrms/attendance/download?month=${selectedMonth}`,

//         {
//           responseType: "blob", // This is crucial for handling file downloads
//         }
//       );
//       const blob = new Blob([response.data], {
//         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//       });
//       saveAs(blob, `attendance_${selectedMonth}.xlsx`);
//     } catch (error) {
//       console.error("Error downloading the Excel file:", error);
//       alert("Failed to download the Excel file. See console for details.");
//     }
//   };

//   const handleButtonClick = () => {
//     fileInputRef.current.click();
//   };

//   // MODIFIED: This function now calls the correct endpoint for uploading attendance data.
//   const handleFileUpload = async (e) => {
//     if (!e.target.files || e.target.files.length === 0) {
//       console.error("No file selected.");
//       return;
//     }
//     const file = e.target.files[0];

//     const formData = new FormData();
//     formData.append("file", file);

//     try {
//       // The API endpoint is updated to the one specified for uploading attendance.
//       const response = await axios.post(
//         // "http://localhost:1051/hrms/uploadEmployeeExcel",
//         "https://api.policicue.com/hrms/uploadEmployeeExcel",

//         formData,
//         {
//           headers: {
//             // Axios will set the correct Content-Type with boundary for multipart/form-data
//             // So explicitly setting it is often not needed.
//           },
//         }
//       );

//       console.log("Response:", response.data);
//       // Displaying the success message from the API response
//       alert(response.data.message || "Upload successful");
//       // Refresh the data on the page to show the newly uploaded information
//       fetchAttendanceData(1, selectedMonth);
//     } catch (err) {
//       console.error("Upload failed", err.response?.data || err);
//       // Displaying the error message from the API response if available
//       alert(
//         err.response?.data?.message ||
//           "Upload failed. Please check the console for details."
//       );
//     }
//   };

//   return (
//     <div className="Payroll">
//       <div className="container-fluid my-2">
//         <div className="row">
//           <main className="mainBodyContainer">
//             <div className="row my-2">
//               <div className="col-9 py-2 px-3">
//                 <h4
//                   className="text-capitalize"
//                   style={{
//                     fontFamily: "ErasDemiITC",
//                     fontWeight: "bold",
//                     marginTop: "1rem",
//                     marginLeft: "12px",
//                   }}
//                 >
//                   Attendance
//                 </h4>
//               </div>
//               <div className="col-3 py-2 px-3 text-end">
//                 <input
//                   type="month"
//                   className="form-control"
//                   value={selectedMonth}
//                   onChange={handleMonthChange}
//                 />
//               </div>
//             </div>

//             <div className="row my-2">
//               <div className="col-12 py-1 px-3">
//                 <div className="bg-white p-2 rounded-3 shadow-sm">
//                   {loading ? (
//                     <p>Loading...</p>
//                   ) : (
//                     <>
//                       <table className="table table-striped table-hover">
//                         <thead>
//                           <tr
//                             className="text-uppercase"
//                             style={{
//                               lineHeight: "15px",
//                               fontFamily: "Calibri",
//                               fontSize: "14px",
//                               color: "#7D90B2",
//                               backgroundColor: "#F4F7FC",
//                             }}
//                           >
//                             <th className="py-3">Employee Name</th>
//                             <th className="text-center py-3">Employee ID</th>
//                             <th className="text-center py-3">Month</th>
//                             <th className="text-center py-3">Working Days</th>
//                             <th className="text-center py-3">Leave Days</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {attendanceData.map((record, index) => (
//                             <tr key={`${record.employee_id}-${index}`}>
//                               <td>{record.employee_name || "--"}</td>
//                               <td className="text-center">
//                                 {record.employee_id || "--"}
//                               </td>
//                               <td className="text-center">
//                                 {record.month || "--"}
//                               </td>
//                               <td className="text-center">
//                                 {record.work_days ?? "--"}
//                               </td>
//                               <td className="text-center">
//                                 {record.leave_days ?? "--"}
//                               </td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </table>

//                       <div className="d-flex justify-content-between align-items-center mt-3 px-2">
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handlePreviousPage}
//                           disabled={currentPage === 1}
//                         >
//                           Previous
//                         </button>
//                         <span>Page {currentPage}</span>
//                         <button
//                           className="btn btn-outline-primary btn-sm"
//                           onClick={handleNextPage}
//                           disabled={currentPage * itemsPerPage >= totalItems}
//                         >
//                           Next
//                         </button>
//                       </div>

//                       <div
//                         style={{
//                           marginTop: "20px",
//                           display: "flex",
//                           gap: "20px",
//                           alignItems: "center",
//                         }}
//                       >
//                         <button
//                           onClick={downloadExcel}
//                           title="Download Excel Sheet"
//                         >
//                           <img
//                             style={{ width: "50px", height: "50px" }}
//                             src={xls}
//                             alt="Download Excel"
//                           />
//                         </button>
//                         <div>
//                           <input
//                             type="file"
//                             accept=".xlsx, .xls"
//                             style={{ display: "none" }}
//                             ref={fileInputRef}
//                             onChange={handleFileUpload}
//                           />
//                           {/* THIS BUTTON TRIGGERS THE MODIFIED handleFileUpload FUNCTION */}
//                           <button
//                             className="btn"
//                             style={{
//                               backgroundColor: "#668c4f",
//                               color: "white",
//                             }}
//                             onClick={handleButtonClick}
//                           >
//                             Upload File
//                           </button>
//                         </div>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </main>
//         </div>
//       </div>
//     </div>
//   );
// }
import React, { useState } from "react";
import {
  Calendar,
  Upload,
  Settings,
  Clock,
  Users,
  UserCheck,
  UserX,
  AlertCircle,
  Edit2,
  Download,
  Search,
  Filter,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";

const Attendance = () => {
  const [activeScreen, setActiveScreen] = useState("dashboard");
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [searchQuery, setSearchQuery] = useState("");

  // Mock data
  const dashboardStats = {
    totalEmployees: 150,
    presentToday: 142,
    absentToday: 5,
    lateArrivals: 8,
    earlyExits: 3,
  };

  const dailyAttendance = [
    {
      id: 1,
      empId: "EMP001",
      name: "Rajesh Kumar",
      date: "2025-11-25",
      inTime: "09:15",
      outTime: "18:30",
      hours: "9h 15m",
      status: "Present",
    },
    {
      id: 2,
      empId: "EMP002",
      name: "Priya Sharma",
      date: "2025-11-25",
      inTime: "09:45",
      outTime: "18:20",
      hours: "8h 35m",
      status: "Late",
    },
    {
      id: 3,
      empId: "EMP003",
      name: "Amit Patel",
      date: "2025-11-25",
      inTime: "09:00",
      outTime: "18:00",
      hours: "9h 00m",
      status: "Present",
    },
    {
      id: 4,
      empId: "EMP004",
      name: "Sneha Gupta",
      date: "2025-11-25",
      inTime: "-",
      outTime: "-",
      hours: "-",
      status: "Absent",
    },
    {
      id: 5,
      empId: "EMP005",
      name: "Vikram Singh",
      date: "2025-11-25",
      inTime: "09:10",
      outTime: "14:00",
      hours: "4h 50m",
      status: "Half Day",
    },
    {
      id: 6,
      empId: "EMP006",
      name: "Ananya Reddy",
      date: "2025-11-25",
      inTime: "09:05",
      outTime: "18:15",
      hours: "9h 10m",
      status: "Present",
    },
  ];

  const monthlyData = {
    empId: "EMP001",
    name: "Rajesh Kumar",
    totalWorkingDays: 22,
    totalPresent: 20,
    absentDays: 1,
    lateDays: 3,
    leaveDays: 1,
    records: Array.from({ length: 30 }, (_, i) => ({
      date: i + 1,
      status:
        i % 7 === 0
          ? "Weekend"
          : i === 5
          ? "Absent"
          : i === 12
          ? "Leave"
          : i % 4 === 0
          ? "Late"
          : "Present",
      inTime: i % 7 === 0 ? "-" : i === 5 ? "-" : "09:" + (10 + (i % 50)),
      outTime: i % 7 === 0 ? "-" : i === 5 ? "-" : "18:" + (10 + (i % 50)),
    })),
  };

  const getStatusColor = (status) => {
    const colors = {
      Present: "bg-green-100 text-green-800",
      Absent: "bg-red-100 text-red-800",
      Late: "bg-yellow-100 text-yellow-800",
      "Half Day": "bg-blue-100 text-blue-800",
      Leave: "bg-purple-100 text-purple-800",
      Weekend: "bg-gray-100 text-gray-800",
      WFH: "bg-indigo-100 text-indigo-800",
    };
    return colors[status] || "bg-gray-100 text-gray-800";
  };

  // Dashboard Screen
  const DashboardScreen = () => (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Total Employees</p>
              <p className="text-3xl font-bold text-gray-900 mt-2">
                {dashboardStats.totalEmployees}
              </p>
            </div>
            <Users className="w-10 h-10 text-blue-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Present Today</p>
              <p className="text-3xl font-bold text-green-600 mt-2">
                {dashboardStats.presentToday}
              </p>
            </div>
            <UserCheck className="w-10 h-10 text-green-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Absent Today</p>
              <p className="text-3xl font-bold text-red-600 mt-2">
                {dashboardStats.absentToday}
              </p>
            </div>
            <UserX className="w-10 h-10 text-red-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Late Arrivals</p>
              <p className="text-3xl font-bold text-yellow-600 mt-2">
                {dashboardStats.lateArrivals}
              </p>
            </div>
            <Clock className="w-10 h-10 text-yellow-500" />
          </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-200">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-gray-600">Early Exits</p>
              <p className="text-3xl font-bold text-orange-600 mt-2">
                {dashboardStats.earlyExits}
              </p>
            </div>
            <AlertCircle className="w-10 h-10 text-orange-500" />
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          <button
            onClick={() => setActiveScreen("daily")}
            className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-blue-500 hover:bg-blue-50 transition-colors"
          >
            <Calendar className="w-6 h-6 text-blue-500 mx-auto mb-2" />
            <p className="text-sm font-medium">View Daily Attendance</p>
          </button>
          <button
            onClick={() => setActiveScreen("monthly")}
            className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-green-500 hover:bg-green-50 transition-colors"
          >
            <Calendar className="w-6 h-6 text-green-500 mx-auto mb-2" />
            <p className="text-sm font-medium">Monthly Reports</p>
          </button>
          <button
            onClick={() => setActiveScreen("upload")}
            className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-purple-500 hover:bg-purple-50 transition-colors"
          >
            <Upload className="w-6 h-6 text-purple-500 mx-auto mb-2" />
            <p className="text-sm font-medium">Upload Attendance</p>
          </button>
          <button
            onClick={() => setActiveScreen("settings")}
            className="p-4 border-2 border-dashed border-gray-300 rounded-lg hover:border-gray-500 hover:bg-gray-50 transition-colors"
          >
            <Settings className="w-6 h-6 text-gray-500 mx-auto mb-2" />
            <p className="text-sm font-medium">Settings</p>
          </button>
        </div>
      </div>
    </div>
  );

  // Daily Attendance Screen
  const DailyAttendanceScreen = () => (
    <div className="space-y-4">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
          <h2 className="text-xl font-semibold">Daily Attendance</h2>
          <div className="flex flex-wrap gap-3 w-full md:w-auto">
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => setSelectedDate(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <div className="relative flex-1 md:flex-initial">
              <Search className="absolute left-3 top-2.5 w-5 h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Search employee..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent w-full md:w-64"
              />
            </div>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2">
              <Download className="w-4 h-4" />
              Export
            </button>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 border-b border-gray-200">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  Employee
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  Emp ID
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  Date
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  In Time
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  Out Time
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  Hours
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  Status
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {dailyAttendance.map((record) => (
                <tr key={record.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm font-medium text-gray-900">
                    {record.name}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {record.empId}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {record.date}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {record.inTime}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {record.outTime}
                  </td>
                  <td className="px-4 py-3 text-sm text-gray-600">
                    {record.hours}
                  </td>
                  <td className="px-4 py-3">
                    <span
                      className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${getStatusColor(
                        record.status
                      )}`}
                    >
                      {record.status}
                    </span>
                  </td>
                  <td className="px-4 py-3">
                    <button className="text-blue-600 hover:text-blue-800">
                      <Edit2 className="w-4 h-4" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  // Monthly Attendance Screen
  const MonthlyAttendanceScreen = () => (
    <div className="space-y-4">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
          <h2 className="text-xl font-semibold">Monthly Attendance Report</h2>
          <div className="flex flex-wrap gap-3">
            <select
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              onChange={(e) => setSelectedEmployee(e.target.value)}
            >
              <option>Select Employee</option>
              <option value="EMP001">Rajesh Kumar</option>
              <option value="EMP002">Priya Sharma</option>
              <option value="EMP003">Amit Patel</option>
            </select>
            <input
              type="month"
              value={selectedMonth}
              onChange={(e) => setSelectedMonth(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 flex items-center gap-2">
              <Download className="w-4 h-4" />
              Export
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600">Total Working Days</p>
            <p className="text-2xl font-bold text-gray-900 mt-1">
              {monthlyData.totalWorkingDays}
            </p>
          </div>
          <div className="bg-green-50 p-4 rounded-lg">
            <p className="text-sm text-green-600">Total Present</p>
            <p className="text-2xl font-bold text-green-700 mt-1">
              {monthlyData.totalPresent}
            </p>
          </div>
          <div className="bg-red-50 p-4 rounded-lg">
            <p className="text-sm text-red-600">Absent Days</p>
            <p className="text-2xl font-bold text-red-700 mt-1">
              {monthlyData.absentDays}
            </p>
          </div>
          <div className="bg-yellow-50 p-4 rounded-lg">
            <p className="text-sm text-yellow-600">Late Days</p>
            <p className="text-2xl font-bold text-yellow-700 mt-1">
              {monthlyData.lateDays}
            </p>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg">
            <p className="text-sm text-purple-600">Leave Days</p>
            <p className="text-2xl font-bold text-purple-700 mt-1">
              {monthlyData.leaveDays}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-7 gap-2">
          {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
            <div
              key={day}
              className="text-center text-sm font-semibold text-gray-600 py-2"
            >
              {day}
            </div>
          ))}
          {monthlyData.records.map((record, idx) => (
            <div
              key={idx}
              className={`p-3 rounded-lg text-center border ${getStatusColor(
                record.status
              )} cursor-pointer hover:shadow-md transition-shadow`}
            >
              <div className="text-sm font-semibold">{record.date}</div>
              <div className="text-xs mt-1">{record.status}</div>
              {record.inTime !== "-" && (
                <div className="text-xs text-gray-600 mt-1">
                  {record.inTime}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  // Manual Upload Screen
  const ManualUploadScreen = () => {
    const [uploadedFile, setUploadedFile] = useState(null);
    const [previewData, setPreviewData] = useState([]);

    const handleFileUpload = (e) => {
      const file = e.target.files[0];
      setUploadedFile(file);
      // Mock preview data
      setPreviewData([
        {
          empId: "EMP001",
          date: "2025-11-25",
          inTime: "09:00",
          outTime: "18:00",
          hours: "9h 00m",
        },
        {
          empId: "EMP002",
          date: "2025-11-25",
          inTime: "09:30",
          outTime: "18:30",
          hours: "9h 00m",
        },
        {
          empId: "EMP003",
          date: "2025-11-25",
          inTime: "09:15",
          outTime: "18:15",
          hours: "9h 00m",
        },
      ]);
    };

    return (
      <div className="space-y-4">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 className="text-xl font-semibold mb-6">
            Manual Attendance Upload
          </h2>

          <div className="mb-6">
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-blue-500 transition-colors">
              <Upload className="w-12 h-12 text-gray-400 mx-auto mb-4" />
              <p className="text-sm text-gray-600 mb-2">
                Drop your Excel file here or click to browse
              </p>
              <input
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={handleFileUpload}
                className="hidden"
                id="file-upload"
              />
              <label
                htmlFor="file-upload"
                className="inline-block px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 cursor-pointer"
              >
                Choose File
              </label>
              {uploadedFile && (
                <p className="text-sm text-green-600 mt-3">
                  ✓ {uploadedFile.name}
                </p>
              )}
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-blue-900 mb-2">
              Excel Format Requirements:
            </h3>
            <ul className="text-sm text-blue-800 space-y-1">
              <li>• Column 1: Employee ID</li>
              <li>• Column 2: Date (YYYY-MM-DD)</li>
              <li>• Column 3: In Time (HH:MM)</li>
              <li>• Column 4: Out Time (HH:MM)</li>
              <li>• Column 5: Working Hours</li>
            </ul>
            <button className="mt-3 text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1">
              <Download className="w-4 h-4" />
              Download Sample Template
            </button>
          </div>

          {previewData.length > 0 && (
            <div>
              <h3 className="font-semibold mb-3">
                Preview Data ({previewData.length} records)
              </h3>
              <div className="overflow-x-auto border border-gray-200 rounded-lg">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                        Emp ID
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                        Date
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                        In Time
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                        Out Time
                      </th>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-600 uppercase">
                        Hours
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {previewData.map((row, idx) => (
                      <tr key={idx}>
                        <td className="px-4 py-3 text-sm">{row.empId}</td>
                        <td className="px-4 py-3 text-sm">{row.date}</td>
                        <td className="px-4 py-3 text-sm">{row.inTime}</td>
                        <td className="px-4 py-3 text-sm">{row.outTime}</td>
                        <td className="px-4 py-3 text-sm">{row.hours}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-end gap-3 mt-4">
                <button className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                  Cancel
                </button>
                <button className="px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700">
                  Submit & Update DB
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  // Settings Screen
  const SettingsScreen = () => (
    <div className="space-y-4">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <h2 className="text-xl font-semibold mb-6">Attendance Settings</h2>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Office Working Hours
            </label>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  Start Time
                </label>
                <input
                  type="time"
                  defaultValue="09:00"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-600 mb-1">
                  End Time
                </label>
                <input
                  type="time"
                  defaultValue="18:00"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Grace Period (minutes)
            </label>
            <input
              type="number"
              defaultValue="15"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <p className="text-xs text-gray-500 mt-1">
              Employees arriving within this time won't be marked late
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Half Day Hours Threshold
            </label>
            <input
              type="number"
              defaultValue="4"
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
            <p className="text-xs text-gray-500 mt-1">
              Working hours below this will be marked as half day
            </p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Shift Timings (Optional)
            </label>
            <div className="space-y-3">
              <div className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
                <input type="checkbox" defaultChecked className="w-4 h-4" />
                <div className="flex-1">
                  <p className="font-medium">General Shift</p>
                  <p className="text-sm text-gray-600">09:00 AM - 06:00 PM</p>
                </div>
                <button className="text-blue-600 hover:text-blue-800">
                  Edit
                </button>
              </div>
              <div className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
                <input type="checkbox" className="w-4 h-4" />
                <div className="flex-1">
                  <p className="font-medium">Night Shift</p>
                  <p className="text-sm text-gray-600">10:00 PM - 07:00 AM</p>
                </div>
                <button className="text-blue-600 hover:text-blue-800">
                  Edit
                </button>
              </div>
            </div>
            <button className="mt-3 text-blue-600 hover:text-blue-800 text-sm font-medium">
              + Add New Shift
            </button>
          </div>

          <div className="pt-4 border-t border-gray-200">
            <button className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
              Save Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">
                Attendance Management
              </h1>
              {/* <p className="text-sm text-gray-600 mt-1">
                Human Resources Portal
              </p> */}
            </div>
            {/* <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">HR Admin</p>
                <p className="text-xs text-gray-600">admin@company.com</p>
              </div>
              <div className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center text-white font-semibold">
                HA
              </div>
            </div> */}
          </div>
        </div>
      </div>

      {/* Navigation */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            <button
              onClick={() => setActiveScreen("dashboard")}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeScreen === "dashboard"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Dashboard
            </button>
            <button
              onClick={() => setActiveScreen("daily")}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeScreen === "daily"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Daily Attendance
            </button>
            <button
              onClick={() => setActiveScreen("monthly")}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeScreen === "monthly"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Monthly Reports
            </button>
            <button
              onClick={() => setActiveScreen("upload")}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeScreen === "upload"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Manual Upload
            </button>
            <button
              onClick={() => setActiveScreen("settings")}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeScreen === "settings"
                  ? "border-blue-500 text-blue-600"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              Settings
            </button>
          </nav>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {activeScreen === "dashboard" && <DashboardScreen />}
        {activeScreen === "daily" && <DailyAttendanceScreen />}
        {activeScreen === "monthly" && <MonthlyAttendanceScreen />}
        {activeScreen === "upload" && <ManualUploadScreen />}
        {activeScreen === "settings" && <SettingsScreen />}
      </div>
    </div>
  );
};

export default Attendance;
